<template>
  <van-action-sheet
    v-model="visible"
    :actions="actions"
    @select="onSelect"
    close-on-click-action
    :cancel-text="cancelText"
    :title="title" />
</template>

<script>
export default {
  name: 'ActionSheet',
  data() {
    return {
      visible: false,
      title: '',
      actions: [],
      cancelText: '取消'
    }
  },
  methods: {
    show({ title = '', actions = [], cancelText = '取消' }) {
      return new Promise((resolve, reject) => {
        this.visible = true
        this.resolve = resolve
        this.reject = reject
        this.title = title
        this.actions = actions
        this.cancelText = cancelText
      })
    },
    onSelect(action) {
      this.resolve(action)
      this.visible = false
    }
  }
}
</script>
